// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Wi2Q","title":"Header_title__3m-85","side":"Header_side__3_PEY"};